import Color from 'color';

export const PRIMARY_COLOR = 'fda4af';
export const SECONDARY_COLOR = '#f7bf08';
export const WHITE_COLOR = '#ffffff';
export const APP_BACKGROUND_COLOR = '#f8f8f5';
export const VERY_LIGHT_GREY_COLOR = '#F0F0F0';
export const GREY = '#b4b4b4';
export const GREY_OUTLINED = 'rgba(0, 0, 0, 0.23)';
export const LIGHT_GREY_OUTLINED = 'rgba(0, 0, 0, 0.12)';
export const LIGHT_GREY_COLOR = '#8b949f';
export const LABEL_BLACK = 'rgba(0, 0, 0, 0.54)';
export const BLACK_COLOR = '#000000';
export const DARK_GREY_COLOR = '#494d55';
export const GOLD_COLOR = '#f7bf08';
export const YELLOW_COLOR = '#ffeb3b';

export const SWEDEN_YELLOW_COLOR = '#FFCD00';

export const RED_COLOR = '#E74843';
export const GREEN_COLOR = '#60c760';
export const PLACEHOLDER_LIGHT = '#F5F5F5';
export const PLACEHOLDER_DARK = '#EEEEEE';
export const DARK_TRANSPARENT_WHITE = 'rgba(255, 255, 255, 0.9)';
export const PRIMARY_COLOR_TRANSPARENT = 'rgba(80, 197, 255, 0.5)';
export const LINKEDIN_BLUE = '#0e76a8';
export const FACEBOOK_BLUE = '#3b5998';
export const TWITTER_BLUE = '#1DA1F2';
export const INSTAGRAM_VIOLET = '#C13584';

export function darkenOrLighten(color) {
  const parsedColor = Color(color);
  return parsedColor.isLight()
    ? parsedColor.desaturate(0.3).darken(0.3).hex()
    : parsedColor.negate().desaturate(0.3).darken(0.3).hex();
}